import { apiFetch } from "jwt-storage-lib";
import { Product } from "@common/build/activeEntityType";
import { Build } from "@common/build/types";
import { formatCurrency } from "./format";

const url = import.meta.env.VITE_URL_HUB_API;
export const mapPriceRange = (product: Product, companySettings?: any): string => {
    const { minPrice, maxPrice } = product;

    if ((!minPrice || Number.isNaN(+minPrice)) && (!maxPrice || Number.isNaN(+maxPrice))) return "";

    const formatPrice = formatCurrency;

    if (minPrice === maxPrice) {
        return `${formatPrice(+minPrice!, companySettings)}`;
    }

    return `${formatPrice(+minPrice!, companySettings)} - ${formatPrice(+maxPrice!, companySettings)}`;
};

export const getTemplates = async (): Promise<Build[]> => {
    const response = await apiFetch(`${url}builds/builder/get-templates`);
    const templates = await response?.json();
    return templates?.map((build: any) => {
        return {
            id: build._id.toString(),
            name: build.name || "",
            pages: JSON.parse(build.pages),
            size: build.size,
            popups: build.popups ? JSON.parse(build.popups) : [],
            cfds: build.cfds ? JSON.parse(build.cfds) : [],
            ...(build.actions ? { actions: build.actions } : {}),
            ...(build.actionBuilder ? { actionBuilder: JSON.parse(build.actionBuilder) } : {})
            // ...(build.globalBlocks ? { globalBlocks: JSON.parse(build.globalBlocks) } : {})
            // extraAttributes?: BuildExtraAttributes;
        };
    });
};

export const getManagedBuilds = async (): Promise<Build[]> => {
    const response = await apiFetch(`${url}builds/builder/get-managed-builds`);
    const rawBuilds = await response?.json();
    return rawBuilds.map((build: any) => {
        return {
            id: build._id.toString(),
            name: build.name || "",
            pages: JSON.parse(build.pages),
            size: build.size,
            popups: build.popups ? JSON.parse(build.popups) : [],
            ...(build.actions ? { actions: build.actions } : {}),
            ...(build.actionBuilder ? { actionBuilder: JSON.parse(build.actionBuilder) } : {}),
            ...(build.globalBlocks ? { globalBlocks: JSON.parse(build.globalBlocks) } : {})
            // extraAttributes?: BuildExtraAttributes;
        };
    });
};
